import { type ComponentProps, lazy, Suspense, useEffect, useState } from 'react';

// The WebGL hero is decoration: load it as its own chunk so it never delays
// the first paint of the page text. The CSS paper background shows meanwhile.
// It is client-only: nothing renders until after mount, so pre-rendered HTML
// and the first client render match (a lazy boundary cannot be pre-rendered).
const Impl = lazy(() => import('./hero-shader').then((m) => ({ default: m.HeroShader })));

export function HeroShader(props: ComponentProps<typeof Impl>) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;
  return (
    <Suspense fallback={null}>
      <Impl {...props} />
    </Suspense>
  );
}
